import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BaseComponent } from '../../shared/components/base/base.component';
import { environment } from '../../../environments/environment';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCard } from '@angular/material/card';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatCard,
    NgOptimizedImage,
  ],
})
export class HeaderComponent extends BaseComponent implements OnInit {
  contactMail = environment.contactMail;
  imgPath = environment.storageImgPath;

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
